export default __webpack_public_path__ + "static/media/castle_card_bg1.ded522e9.png";